import React, { useState } from 'react';
import { OrderComparison } from '../../../types/comparative';
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';
import OFIMASyncModal from './OFIMASyncModal';

interface ComparisonActionsProps {
  comparisons: OrderComparison[];
  selectedStore: string;
  onRefresh?: () => void;
  onSyncMissing?: (missingOrders: OrderComparison[]) => void;
  onFixDiscrepancies?: (discrepantOrders: OrderComparison[]) => void;
}

const ComparisonActions: React.FC<ComparisonActionsProps> = ({
  comparisons,
  selectedStore,
  onRefresh,
  onSyncMissing,
  onFixDiscrepancies
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isSyncing] = useState(false); // Usado en código comentado
  const [isSyncModalOpen, setIsSyncModalOpen] = useState(false);

  const missingOrders = comparisons.filter(c => c.comparison.syncStatus === 'missing');
  // const discrepantOrders = comparisons.filter(c => c.comparison.syncStatus === 'discrepancy'); // Usado solo en código comentado

  const handleSyncMissing = () => {
    if (missingOrders.length === 0) {
      toast.error('No hay pedidos faltantes para sincronizar');
      return;
    }

    if (selectedStore !== 'OFIMA') {
      toast.error('La sincronización automática solo está disponible para OFIMA');
      return;
    }

    setIsSyncModalOpen(true);
  };

  const handleSyncComplete = () => {
    toast.success('Sincronización completada exitosamente', {
      icon: '🔄'
    });
    onSyncMissing?.(missingOrders);
    onRefresh?.();
  };

  // Función comentada - no se usa actualmente
  // const handleFixDiscrepancies = async () => {
  //   if (discrepantOrders.length === 0) {
  //     toast.error('No hay discrepancias para corregir');
  //     return;
  //   }
  //
  //   setIsSyncing(true);
  //   try {
  //     // Simular corrección de discrepancias
  //     await new Promise(resolve => setTimeout(resolve, 3000));
  //     
  //     toast.success(`${discrepantOrders.length} discrepancias corregidas exitosamente`, {
  //       icon: '🔧'
  //     });
  //     
  //     onFixDiscrepancies?.(discrepantOrders);
  //   } catch (error) {
  //     toast.error('Error al corregir discrepancias');
  //   } finally {
  //     setIsSyncing(false);
  //   }
  // };

  if (comparisons.length === 0) {
    return null;
  }

  return (
    <div className="">
{/*       <h3 className="text-lg font-semibold text-blue-800 mb-4">Acciones de Comparación</h3>   */}  
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Exportar Resultados */}
{/*         <div className="space-y-2">
          <h4 className="text-sm font-medium text-gray-700">Exportar Resultados</h4>
          <div className="flex space-x-2">
            <button
              onClick={() => handleExport('excel')}
              disabled={isExporting}
              className="flex-1 px-3 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-sm flex items-center justify-center gap-2"
            >
              {isExporting ? (
                <ArrowPathIcon className="w-4 h-4 animate-spin" />
              ) : (
                <DocumentArrowDownIcon className="w-4 h-4" />
              )}
              Excel
            </button> 
            <button
              onClick={() => handleExport('pdf')}
              disabled={isExporting}
              className="flex-1 px-3 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-sm flex items-center justify-center gap-2"
            >
              {isExporting ? (
                <ArrowPathIcon className="w-4 h-4 animate-spin" />
              ) : (
                <DocumentArrowDownIcon className="w-4 h-4" />
              )}
              PDF
            </button> 
          </div>  </div>*/}
        {/* Sincronizar Faltantes */}
       <div className="space-y-2">
{/*           <h4 className="text-sm font-medium text-gray-700">
            Sincronizar Faltantes ({missingOrders.length})
          </h4> */}
          <button
            onClick={handleSyncMissing}
            disabled={isSyncing || missingOrders.length === 0}
            className="w-full px-3 py-2 bg-orange-600 text-white rounded-md hover:bg-orange-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-sm flex items-center justify-center gap-2"
          >
            {isSyncing ? (
              <ArrowPathIcon className="w-4 h-4 animate-spin" />
            ) : (
              <ArrowPathIcon className="w-4 h-4" />
            )}
            Sincronizar
          </button>
        </div>

        {/* Corregir Discrepancias */}
{/*         <div className="space-y-2">
          <h4 className="text-sm font-medium text-gray-700">
            Corregir Discrepancias ({discrepantOrders.length})
          </h4>
          <button
            onClick={handleFixDiscrepancies}
            disabled={isSyncing || discrepantOrders.length === 0}
            className="w-full px-3 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-sm flex items-center justify-center gap-2"
          >
            {isSyncing ? (
              <ArrowPathIcon className="w-4 h-4 animate-spin" />
            ) : (
              <ExclamationTriangleIcon className="w-4 h-4" />
            )}
            Corregir
          </button>
        </div> */}

        {/* Refrescar Datos */}
        <div className="space-y-2">
{/*           <h4 className="text-sm font-medium text-gray-700">Actualizar Datos</h4>
 */}          <button
            onClick={onRefresh}
            disabled={isSyncing}
            className="w-full px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-sm flex items-center justify-center gap-2"
          >
            <ArrowPathIcon className="w-4 h-4" />
            Refrescar
          </button>
        </div>
      </div>

      {/* Resumen de Estado */}
{/*       <div className="mt-4 p-3 bg-gray-50 rounded-md">
        <div className="grid grid-cols-3 gap-4 text-center">
          <div className="flex items-center justify-center gap-2">
            <CheckCircleIcon className="w-5 h-5 text-green-500" />
            <span className="text-sm font-medium text-gray-700">
              Sincronizados: {synchronizedOrders.length}
            </span>
          </div>
          <div className="flex items-center justify-center gap-2">
            <ExclamationTriangleIcon className="w-5 h-5 text-red-500" />
            <span className="text-sm font-medium text-gray-700">
              Faltantes: {missingOrders.length}
            </span>
          </div>
          <div className="flex items-center justify-center gap-2">
            <ExclamationTriangleIcon className="w-5 h-5 text-yellow-500" />
            <span className="text-sm font-medium text-gray-700">
              Discrepancias: {discrepantOrders.length}
            </span>
          </div> 
        </div>
      </div>
 */}
      {/* Modal de Sincronización OFIMA */}
      <OFIMASyncModal
        isOpen={isSyncModalOpen}
        onClose={() => setIsSyncModalOpen(false)}
        missingOrders={missingOrders}
        onSyncComplete={handleSyncComplete}
      />
    </div>
  );
};

export default ComparisonActions;
